module.exports = __webpack_public_path__ + "static/img/12.2ffe785.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/zh/12.png
// module id = cGzU
// module chunks = 0